<div class="card">
  <app-header
    titulo="Publicações"
    descricao="Gerenciamento de APIs públicas e Webhooks gerados pelos processos de integração.">
  </app-header>

  <p-table
    [value]="publicacoes"
    [loading]="loading"
    styleClass="p-datatable-sm p-datatable-striped"
    [paginator]="true"
    [rows]="20"
    [globalFilterFields]="['nome', 'descricao']">

    <ng-template pTemplate="caption">
      <div class="flex justify-content-between align-items-center">
        <p-button
          label="Atualizar"
          icon="pi pi-refresh"
          (onClick)="carregarPublicacoes()"
          [loading]="loading">
        </p-button>
        <!-- Filtros podem ser adicionados aqui -->
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="direcao">Direção <p-sortIcon field="direcao"></p-sortIcon></th>
        <th>Endpoint da API</th>
        <th pSortableColumn="ativo">Status <p-sortIcon field="ativo"></p-sortIcon></th>
        <th style="width: 10rem">Ações</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-pub>
      <tr>
        <td><strong>{{ pub.nome }}</strong></td>
        <td>
          <p-tag [value]="pub.direcao" [severity]="getDirecaoSeverity(pub.direcao)"></p-tag>
        </td>
        <td>
          <div class="endpoint-url">
            <p-tag [value]="getMetodoHttp(pub.direcao)" [severity]="getMetodoHttp(pub.direcao) === 'GET' ? 'info' : 'warning'" styleClass="mr-2"></p-tag>
            <code>{{ apiUrl }}/publicacao/{{ pub.id }}</code>
            <i class="pi pi-copy ml-2" (click)="copyUrl(apiUrl + '/publicacao/' + pub.id)"></i>
          </div>
        </td>
        <td>
          <p-tag [value]="pub.ativo ? 'Ativo' : 'Inativo'" [severity]="pub.ativo ? 'success' : 'danger'"></p-tag>
        </td>
        <td>
          <button pButton pRipple icon="pi pi-bolt" class="p-button-rounded p-button-info p-button-text" pTooltip="Testar Endpoint"></button>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="deletarPublicacao(pub)"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center p-4">Nenhuma publicação encontrada.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
